export default "__VITE_ASSET__Bh6shN93__"